import axios from 'axios';

export class BaseService {

    constructor() {
    }

    setCredentials(credentials) {
        this._credentials = credentials;
    }

    headers() {
        const assessToken = sessionStorage.getItem('access_token');

        if(assessToken) {
            return {
                headers: { Authorization: `${assessToken}` },
            }
        } else {
            return {}
        }
    }

    getCredentials() {
        return this._credentials;
    }

    getCurrentUrl(path) {
        if (this._credentials) {
            return `${this._credentials.URL}${path}`;
        }

        return `${path}`;
    }

    async get(route) {
        const url = this.getCurrentUrl(route);
        return await axios.get(url, this.headers())
    }

    async post(
        route,
        data,
        customHeaders = {},
    ) {
        const url = this.getCurrentUrl(route);
        const headers = this.headers().headers;
        const result = await axios.post(url, data, {
            headers: { ...headers, ...customHeaders },
        });
        return result;
    }

    async put(route, data) {
        const url = this.getCurrentUrl(route);
        const result = await axios.put(url, data, this.headers);
        return result;
    }

    async patch(route, data, customHeaders = {}) {
        const url = this.getCurrentUrl(route);
        const result = await axios.patch(url, data, {
            headers: { ...this.headers.headers, ...customHeaders },
        });
        return result;
    }

    async remove(route) {
        const url = this.getCurrentUrl(route);
        const result = await axios.delete(url, this.headers);
        return result;
    }
}